import React from "react";
import { Alert, Spin } from "antd";
import { useSelector } from "react-redux";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import TextComponent from "../textComponent/TextComponent";

const Loading = () => {
  const loading = useSelector((state) => state.GeneralReducer.loading);

  const GradientLoadingIcon = () => {
    return (
      <svg
        width="100"
        height="100"
        viewBox="0 0 1024 1024"
        style={{ display: "inline-block" }}
      >
        <defs>
          <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="var(--primary-color)" />
            <stop offset="100%" stopColor="var(--secondary-color)" />
          </linearGradient>
        </defs>
        <mask id="mask">
          <Loading3QuartersOutlined
            style={{
              fontSize: 100,
            }}
          />
        </mask>
        <rect width="100%" height="100%" fill="url(#grad)" mask="url(#mask)" />
      </svg>
    );
  };

  const antIcon = (
    <div
      className="gradient-icon"
      style={{
        background:
          "linear-gradient(45deg, var(--primary-color), var(--secondary-color))",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Loading3QuartersOutlined style={{ fontSize: 70 }} spin />
    </div>
  );

  return loading ? (
    <div className="loadingClass">
      <Spin indicator={GradientLoadingIcon} />
      <TextComponent
        text="Loading ..."
        style={{
          background:
            "linear-gradient(45deg, var(--primary-color), var(--secondary-color))",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent",
          fontSize: "25px",
          fontWeight: "bold",
          marginTop: 15,
        }}
      />
    </div>
  ) : null;
};

export default Loading;
